/** How long a pop-up slide stays on screen before it counts as seen ("shown"). */
const SLIDE_SHOWN_DWELL_MS = 3000;
/**
 * Hours after the customer closes the page's pop-up during which no page asks for another, in any
 * tab or after a reload. The PRD allows as little as 10.
 */
const POPUP_COOLDOWN_HOURS = 24;
/** How many days from today an announcement expires, unless the form says otherwise. */
const DEFAULT_EXPIRY_DAYS = 35;
/** The line above a pop-up's headline, by the kind of change; "New" when none is set. */
const NOTIFICATION_EYEBROWS = {
    new: "New in Discover",
    improved: "Updated in Discover",
};
/** Default button copy per resolved variant; the back end sends the label it chose. */
const NOTIFICATION_CTA_LABELS = {
    watch_demo: "Watch demo",
    go_to_feature: "Take me there",
    learn_more: "Learn more",
};
/**
 * The tag each change type is saved as: the API keeps no change type, and stores tags as sent. No
 * such tag reads as the pop-up's own change type.
 */
const NOTIFICATION_CHANGE_TYPE_TAGS = {
    new: "new",
    improved: "updated",
};
const CHANGE_TYPE_TAGS = Object.values(NOTIFICATION_CHANGE_TYPE_TAGS);
/** The change type an announcement's tags name, if any. */
const changeTypeOfTags = (tags) => {
    if (tags === null || tags === void 0 ? void 0 : tags.includes(NOTIFICATION_CHANGE_TYPE_TAGS.improved))
        return "improved";
    if (tags === null || tags === void 0 ? void 0 : tags.includes(NOTIFICATION_CHANGE_TYPE_TAGS.new))
        return "new";
    return undefined;
};
/**
 * The eyebrow written for an announcement, saved as a tag: the API has no field for it and stores
 * tags as sent (What's New API contract), the change type's way. "eyebrow:Just shipped".
 */
const NOTIFICATION_EYEBROW_TAG_PREFIX = "eyebrow:";
/** The eyebrow an announcement's tags carry, if any. */
const eyebrowOfTags = (tags) => {
    var _a;
    return ((_a = tags === null || tags === void 0 ? void 0 : tags.find((tag) => tag.startsWith(NOTIFICATION_EYEBROW_TAG_PREFIX))) === null || _a === void 0 ? void 0 : _a.slice(NOTIFICATION_EYEBROW_TAG_PREFIX.length).trim()) || undefined;
};
/** The tags with this eyebrow in place of any other; none written, none kept. The rest stay as they were. */
const withEyebrowTag = (tags, eyebrow) => [
    ...tags.filter((tag) => !tag.startsWith(NOTIFICATION_EYEBROW_TAG_PREFIX)),
    ...(eyebrow.trim() ? [`${NOTIFICATION_EYEBROW_TAG_PREFIX}${eyebrow.trim()}`] : []),
];
/** The tags with this change type's in place of any other; the rest are kept as they were. */
const withChangeTypeTag = (tags, changeType) => [
    ...tags.filter((tag) => !CHANGE_TYPE_TAGS.includes(tag)),
    ...(changeType ? [NOTIFICATION_CHANGE_TYPE_TAGS[changeType]] : []),
];
/**
 * "No button", saved as a tag: an announcement with no action reads as no button once published, but
 * a draft with none may just not have one picked yet; the tag keeps the choice.
 */
const NOTIFICATION_NO_BUTTON_TAG = "cta:none";
/** The tags with the "No button" tag when there is no main button, and without it otherwise. */
const withNoButtonTag = (tags, noButton) => [
    ...tags.filter((tag) => tag !== NOTIFICATION_NO_BUTTON_TAG),
    ...(noButton ? [NOTIFICATION_NO_BUTTON_TAG] : []),
];

export { DEFAULT_EXPIRY_DAYS, NOTIFICATION_CHANGE_TYPE_TAGS, NOTIFICATION_CTA_LABELS, NOTIFICATION_EYEBROWS, NOTIFICATION_EYEBROW_TAG_PREFIX, NOTIFICATION_NO_BUTTON_TAG, POPUP_COOLDOWN_HOURS, SLIDE_SHOWN_DWELL_MS, changeTypeOfTags, eyebrowOfTags, withChangeTypeTag, withEyebrowTag, withNoButtonTag };
